const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  }
}

export default styles
